// extracted by mini-css-extract-plugin
module.exports = {"hero":"DocHero_hero__TTiXO","inner":"DocHero_inner__HZ2zr","eyebrow":"DocHero_eyebrow__8b4_Y","title":"DocHero_title__oIq69","intro":"DocHero_intro__JVojw"};